import { useCallback } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectItem,
  SelectTrigger,
  Text,
  TuneIcon,
  ViewListIcon,
} from '@billda/design-system';
import { useShallow } from 'zustand/react/shallow';
import { PageHeaderAction } from '../../../shared/components/layout/PageHeaderAction';
import {
  usePotApprovalsUIStore,
  type PotGroupingMode,
} from '../stores/potApprovalsUIStore';

export function PotGroupingMenu() {
  const { groupingMode, setGroupingMode } = usePotApprovalsUIStore(
    useShallow(state => ({
      groupingMode: state.groupingMode,
      setGroupingMode: state.setGroupingMode,
    }))
  );

  const handleGroupingChange = useCallback(
    (value: string) => setGroupingMode(value as PotGroupingMode),
    [setGroupingMode]
  );

  return (
    <Popover>
      <PopoverTrigger asChild>
        <PageHeaderAction
          label="Display"
          icon={<TuneIcon />}
          data-testid="pot-display-button"
        />
      </PopoverTrigger>
      <PopoverContent
        align="start"
        aria-label="Pot display options"
        className="min-w-70"
      >
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <ViewListIcon
              aria-hidden="true"
              className="size-4 text-content-secondary"
            />
            <Text variant="body2" color="secondary">
              Grouping
            </Text>
          </div>
          <Select value={groupingMode} onValueChange={handleGroupingChange}>
            <SelectTrigger
              aria-label="Group pots by"
              data-testid="pot-grouping-select"
              className="min-w-35 bg-surface-raised text-[13px]"
            />
            <SelectItem value="none">None</SelectItem>
            <SelectItem value="status">Status</SelectItem>
          </Select>
        </div>
      </PopoverContent>
    </Popover>
  );
}
